import { sandboxLogic } from './sandbox.logic';

import { SandboxHostView, SandboxProjectorView, SandboxStudentView } from './SandboxViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const sandboxPlugin: ActivityPlugin<'sandbox'> = {

  ...sandboxLogic,

  displayName: GAME_MODE_CATALOG.sandbox.displayName,

  icon: GAME_MODE_CATALOG.sandbox.icon,

  HostView: SandboxHostView,

  StudentView: SandboxStudentView,

  ProjectorView: SandboxProjectorView,

};



export {

  demoSandboxPayload,

  demoBalanzaPayload,

  demoFraccionesPayload,

  demoInflationMarketPayload,

  demoEcuacionesPayload,

  demoGobernabilidadPayload,

} from './sandbox.logic';

